import React from 'react'
import PropTypes from 'prop-types';

import Text from './Text'


const Section = (props) => {
  if (!props.copy) {
    return false;
  }

  const header = props.copy.title ? <h2>{props.copy.title}</h2> : false;

  return (
    <section>
      {header}
      <Text>{props.copy.text}</Text>
      {props.children}
    </section>
  )
}

Section.propTypes = {
  copy: PropTypes.object
}

export default Section



// WEBPACK FOOTER //
// ./src/Section.js